import React, { useState, useEffect } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { Row, Col, message } from "antd";
import { getApi } from "../../../Services/apiService";
import { GET_BOOKING_DETAILS, HUMS_ACKNOWLEDGEMENT, JWT_LOGIN, JWT_REFRESH } from "../../../Services/endpoints";
import { getTokenTimestamp, scrollToTop } from "../../../Utils";
import { Wrapper, CustomLabel } from "../../../Common/style";
import MemberTabDetails from "./MemberTabDetails";
import PAGE_CONSTANTS from "./constant";
import { error_message } from "../../../Constant";
import { PolicyDetails, AppointmentDetails } from "../CommonData";
import { fetchAppointmentDetails } from "../../../Redux/AppointmentDetails/action";
import { resetBookMemberDetails } from "../../../Redux/BookMedicalVisit/action";
import { SET_APP_SOURCE, SET_BEARER_TYPE } from "../../../Redux/PolicyNumber/types";
import { SET_APPOINTMENT_LOADED } from "../../../Redux/AppointmentDetails/types";
import { GET_PPMC_DETAILS } from "../../../Services/endpoints";
import { postApi } from "../../../Services/apiService";
import { getPolicyDetails } from "../../../Redux/PolicyNumber/action";
import { decrypt, encrypt } from "../../../Services/AESEncryptionDecryption";
import { getURlParameter } from "../../../Constant";
import { arrowBackIcon } from "../../../Assets/Images";
import "./style.css";


const CustomCardHeading = styled.div`
  font-size: 24px;
  text-align: left;
  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

const AppointmentBookingPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isExternalSource, setIsExternalSource] = useState(false);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  const {
    proposalDetails,
    applicationID,
    policyNum,
    appSource,
    bearerObj
  } = PolicyDetails();
  const {
    AppointmentBookings,
    isLoaded
  } = AppointmentDetails()

  const byPassApiCall = async (policyNum, sourceType) => {
    dispatch({type: SET_APPOINTMENT_LOADED, payload: false})
    try {
      const payload = {
        policyNum: null,
        applicationID: policyNum,
        source: sourceType
      }
      const bearerTn = await getAccTn();
      const encodedPayload = encrypt(JSON.stringify(payload))
      const result = await postApi(GET_PPMC_DETAILS, {
        encodedString: encodedPayload,
      },{ headers: {'Authorization': `Bearer ${bearerTn}`} });
      if (result?.data?.response) {
        //DISPATCH POLICY DETAILS
        const decryptResponse = JSON?.parse(decrypt(result?.data?.response));
        dispatch(getPolicyDetails(decryptResponse));
        getBookingDetails(decryptResponse?.policyNum);
      }
      else if(result?.data?.errorMessage){
        dispatch({type: SET_APPOINTMENT_LOADED, payload: true})
        message?.error(result?.data?.errorMessage)
      }
    } 
    catch (error) {
      dispatch({type: SET_APPOINTMENT_LOADED, payload: true})
      message?.error(error_message?.common_error);
    }
  };
  const refresh = async () => {
    if (bearerObj) {
      const obj = JSON?.parse(decrypt(bearerObj));
      const access = obj?.access;
      try {
        const response = await postApi(JWT_REFRESH, "", {
          headers: { Authorization: `Bearer ${access}` },
        });
        const decryptResponse = JSON?.parse(decrypt(response?.data));
        const obj = {
          access: decryptResponse?.access_token,
          time: getTokenTimestamp(),
          refresh: decryptResponse?.refresh_token,
        };
        const eto = encrypt(JSON.stringify(obj));
        dispatch({ type: SET_BEARER_TYPE, payload: eto });
        return decryptResponse?.access_token;
      } catch (error) {
        console.error("t refresh failed", error);
      }
    }
  };
  const getAccTn = async () => {
    if (bearerObj) {
      const obj = JSON?.parse(decrypt(bearerObj));
      const time = obj?.time;
      const access = obj?.access;
      const currentTime = moment().unix() * 1000; // Current time in milliseconds
      const threshold = 10;
      const minutesBeforeExpiration = time - threshold * 60 * 1000; // threshold minutes to ms
      if (currentTime >= minutesBeforeExpiration) {
        // Trigger t generate if the t is expired
        if (currentTime >= time) {
          const newFetchedTn = await generateTn();
          return newFetchedTn;
        } // Trigger t refresh if the t is about to expire
        else {
          const newTn = await refresh();
          return newTn;
        }
      } else {
        return access;
      }
    } //Generate access t
    else {
      const newTn = await generateTn();
      return newTn;
    }
  };
  const generateTn = async () => {
    try {
      const payload = {
        username: "Administrator",
        password: process.env.REACT_APP_TOKEN_PASSWORD,
      };
      const encodedPayload = encrypt(JSON.stringify(payload));
      const result = await postApi(JWT_LOGIN, {
        encodedString: encodedPayload,
      });
      const decryptResponse = JSON?.parse(decrypt(result?.data));
      if (decryptResponse?.access_token) {
        const obj = {
          access: decryptResponse?.access_token,
          time: getTokenTimestamp(),
          refresh: decryptResponse?.refresh_token,
        };
        const eto = encrypt(JSON.stringify(obj));
        dispatch({ type: SET_BEARER_TYPE, payload: eto });
        return decryptResponse?.access_token;
      }
    } catch (error) {
      console.error(error);
    }
  };

  const checkDefaultParams = () => {
    const query = getURlParameter("q");
    const getSource = (type) => {
      if(type === "buyOnline"){
        return "BOL";
      }
      else if(type === "sellOnline"){
        return "SOL";
      }
      else {
        return type;
      }
    }
    if (query) {
      setIsExternalSource(true);
      const decryptText = decrypt(query);
      const parsedData = JSON?.parse(decryptText);
      const appNo = parsedData?.pno;
      const sourceType = getSource(parsedData?.source);
      dispatch({
        type: SET_APP_SOURCE,
        payload: {source: sourceType},
      });
      byPassApiCall(appNo, sourceType);
    }
    else {
      getBookingDetails();
    }
  }

  const humsApiCall = async () => {
    if(appSource !== "APPTRACKER"){
      const payload = {
        ApplicationNo: applicationID,
      }
      const encryptedText = encrypt(JSON?.stringify(payload));
      try {
        const result = await postApi(HUMS_ACKNOWLEDGEMENT, {
          encodedString: encryptedText,
        });
        if(result?.data?.errorMessage){
          message.error(result?.data?.errorMessage);
        }
      } catch (error) {
        message.error(error_message?.common_error);
       }
    }
  }

const getBookingDetails = async (pno = policyNum) => {
  try {
    const encryptedPno = encrypt(pno?.trim())
    const url = `${GET_BOOKING_DETAILS}?applicationNumber=${encodeURIComponent(encryptedPno)}`
    const result = await getApi(url);
    if(result?.data?.response){
      dispatch(fetchAppointmentDetails({
        Application_Number: result?.data?.response?.Application_Number,
        Insured_Info: result?.data?.response?.Insured_Info?.filter((insured) => insured?.Appointment_preferred_time1),
       }));
    }
    dispatch({type: SET_APPOINTMENT_LOADED, payload: true})
  } catch (error) {
    dispatch({type: SET_APPOINTMENT_LOADED, payload: true})
    console.error(error)
    message.error(error?.errorMessage)
   }
};
const setDefaultTabIndex = () => {
  const memberArr = [];
  proposalDetails?.MemberDetails?.forEach((memberItem) => {
    if((memberItem?.MedicalTestSet && memberItem?.MedicalTestSetName) || memberItem?.MedicalTest){
      memberArr?.push(memberItem);
    }
  })
  if(memberArr[0]){
    const index = proposalDetails?.MemberDetails?.findIndex((item) => item?.MemberId === memberArr[0]?.MemberId)
    setSelectedTabIndex(index)
  }
}

  const onTabClick = (value, member) => {
    setSelectedTabIndex(value);
  };
  const getAppointmentBookingByMemberId = (memberId) => {
    return AppointmentBookings?.find((appointment) => appointment?.Member_id === memberId)
  }
  const memberTabs = proposalDetails?.MemberDetails?.map((memberItem, index) => {
    if((memberItem?.MedicalTestSet && memberItem?.MedicalTestSetName) || memberItem?.MedicalTest){
      return (
        <li onClick={() => onTabClick(index, memberItem)} key={index}>
          <span
            id={"memberTab-" + index}
            className={
              index === selectedTabIndex ? `memberTabBar active` : `memberTabBar`
            }
          >
            {memberItem?.FirstName}
          </span>
        </li>
      );
    }
  });

  useEffect(() => {
    scrollToTop();
    dispatch(resetBookMemberDetails());
    checkDefaultParams();
    setDefaultTabIndex();
  }, []);
  return (
    <>
      <section>
        {!isExternalSource && <div
          className="arrow-back"
          style={{ padding: "10px", marginTop: "12px" }}
        >
          <div className="arrow-back-container">
            <img
              src={arrowBackIcon}
              alt="back"
              onClick={()=> navigate(-1)}
              style={{ marginRight: "10px", cursor: "pointer" }}
            />
            <CustomLabel font_size="14" font_weight="bold">
              {PAGE_CONSTANTS?.APPLICATION_TRACKER}
            </CustomLabel>
          </div>
        </div>}
        <div className={`container ${isExternalSource && 'pt-head'}`}>
          <Wrapper style={{ width: "100%", margin: "auto" }}>
            <Row>
              <Col lg={24} md={24}>
                <CustomCardHeading style={{ marginBottom: "33px" }}>
                  {PAGE_CONSTANTS?.MEDICAL_APPOINTMENT_BOOKING}
                </CustomCardHeading>
              </Col>
            </Row>
            <div className="member-tab-wrapper">
              <div className="tab_names my-4">
                <ul className="nav nav-tabs">{memberTabs}</ul>
              </div>
            </div>
            {isLoaded && policyNum ? <MemberTabDetails
              selectedMember={proposalDetails?.MemberDetails[selectedTabIndex]}
              applicationNumber={proposalDetails?.ApplicationNo}
              bookedAppointment={getAppointmentBookingByMemberId(proposalDetails?.MemberDetails[selectedTabIndex]?.MemberId)}
              humsApiCall={humsApiCall}
            /> : null}
          </Wrapper>
        </div>
      </section>
    </>
  );
};

export default AppointmentBookingPage;
